<template>

    <v-modal title="Add Element">

        <template #body>
            <v-alert :message="error" />
            <div class="elements">
                <div class="element" v-for="el in displayableElements" :key="el.type" @click="createElement(el.type)">
                    <div class="element-body">
                        <v-icon class="mr-15" :type="el.type" />
                        <span>{{ el.name }}</span>
                    </div>
                    <div class="element-footer">
                        <v-button size="sm" btn-style="secondary" :loading="loading === el.type">Add</v-button>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <div></div>
        </template>

    </v-modal>

</template>

<style scoped lang="scss">

    .elements {
        display: grid;
        gap: 5px;
    }

    .element {
        @include font-medium(15px);
        align-items: center;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        padding: 10px 15px;
        &:hover {
            border-color: $color-text;
        }
        .element-body {
            align-items: center;
            display: flex;
        }
    }

</style>

<script>

import ElementIcon from '@pages/forms-edit/components/ElementIcon';
import FormApi from '@api/FormApi';

export default {

    components: {
        'v-icon': ElementIcon,
    },

    data() {
        return {
            loading: false,
            error: null,
            elements: [
                { type: 'email', name: 'Email' },
                { type: 'name', name: 'Name' },
                { type: 'first_name', name: 'First Name' },
                { type: 'last_name', name: 'Last Name' },
                { type: 'phone', name: 'Phone' },
                { type: 'text_short', name: 'Short Text' },
                { type: 'text_long', name: 'Long Text' },
                { type: 'checkbox', name: 'Checkbox' },
            ],
        }
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

        displayableElements() {
            const repeatable = ['text_short', 'text_long', 'checkbox'];
            return this.elements.filter(e => {
                if (repeatable.includes(e.type)) return true;
                return (!this.form.elements.find(fe => fe.type === e.type));
            });
        },

    },

    methods: {

        createElement(type) {
            this.loading = type;
            FormApi.createElement(this.form.id, { type: type })
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('form/setElements', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
